module.exports = __webpack_public_path__ + "static/media/screen-linkedin-tiloli.5182bf80.png";